<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page
    [breadcrumb]="
      breadcrumb.length
        ? breadcrumb
        : [
            {label: titlePath | translate, path: '/settings'},
            {label: title | translate}
          ]
    "
    [title]="title | translate"
  >
    <div page-body>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</ng-template>

<ng-template #contentTemplate>
  <div
    *ngIf="availableKeysForAdd.length > 0"
    class="gw-mb-6 gw-flex gw-justify-end"
  >
    <gatewee-button
      variant="primary"
      iconName="@phi.plus"
      [title]="'features.settings.addParameter' | translate"
      (clicked)="onAddParameter()"
    ></gatewee-button>
  </div>

  <div
    class="gw-rounded-xl gw-shadow-sm gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-overflow-hidden"
  >
    <gatewee-table-v2
      *ngIf="tableData && columns.length"
      [data]="tableData"
      [columns]="columns"
      [page]="1"
      [pageSize]="tableData.length || 1"
      [total]="tableData.length"
      [showSettings]="true"
      [tableId]="'settings-table'"
      [getRowClass]="getRowClass"
      (outClick)="onActionClicked($event)"
    ></gatewee-table-v2>
  </div>
</ng-template>

<ng-template #confirmEditDialog let-observer let-data="data">
  <div class="gw-space-y-4">
    <p class="gw-text-text-primary">
      {{
        'features.settings.confirmEdit.message'
          | translate : {key: data?.setting?.key || ''}
      }}
    </p>
    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="primary"
        [title]="'features.settings.confirmEdit.confirmButton' | translate"
        (click)="observer.next(true); observer.complete()"
      ></gatewee-button>
    </div>
  </div>
</ng-template>

<ng-template #addParameterSelectDialog let-observer let-data="data">
  <div class="gw-space-y-4 gw-p-4">
    <gatewee-select-v3
      [label]="'features.settings.addParameterDialog.selectLabel' | translate"
      [placeholder]="
        'features.settings.addParameterDialog.placeholder' | translate
      "
      [items]="data?.availableKeyOptions || []"
      [(ngModel)]="selectedKeyForAdd"
    ></gatewee-select-v3>
    <div class="gw-flex gw-justify-end gw-gap-3">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="observer.next(undefined); observer.complete()"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'features.settings.addParameterDialog.next' | translate"
        [disabled]="!selectedKeyForAdd"
        (clicked)="observer.next(selectedKeyForAdd); observer.complete()"
      ></gatewee-button>
    </div>
  </div>
</ng-template>
